module.exports = __webpack_public_path__ + "img/contratos-exequiales.6473458c.svg";